(function(){
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function reveal(scope){
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.nsx .reveal:not(.in)');
    if (!els.length) return;
    // In the theme editor (and if the observer is unsupported), show everything
    // immediately so nothing is ever invisible while merchants are editing.
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function(e){ e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e, i){
        if (e.isIntersecting) { setTimeout(function(){ e.target.classList.add('in'); }, (i % 3) * 70); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function(e){ io.observe(e); });
    // Safety net: if anything is still hidden after 1.4s, reveal it.
    setTimeout(function(){
      root.querySelectorAll('.nsx .reveal:not(.in)').forEach(function(e){ e.classList.add('in'); });
    }, 1400);
  }

  function run(){ reveal(document); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);

  // Re-run when the theme editor injects, loads, or selects a section.
  document.addEventListener('shopify:section:load', function(e){ reveal(e.target); });
  document.addEventListener('shopify:section:select', function(e){ reveal(e.target); });
})();

/* "Buy more, save more" pack selector — swaps the cart variant + toggles the subscribe block */
(function(){
  function wire(scope){
    (scope || document).querySelectorAll('.ns-pk').forEach(function(pk){
      if (pk.dataset.nsBound) return; pk.dataset.nsBound = '1';
      var form = pk.closest('form');
      var idInput = form && form.querySelector('input[name="id"]');
      var sub = form && form.querySelector('.ns-po'); // one-time / subscribe block
      pk.addEventListener('change', function(e){
        var t = e.target;
        if (!t || t.name !== 'ns-pack') return;
        var isSingle = t.getAttribute('data-single') === '1';
        if (idInput) idInput.value = t.getAttribute('data-variant');
        if (sub) {
          sub.style.display = isSingle ? '' : 'none';
          if (!isSingle) { var ot = sub.querySelector('input[value=""]'); if (ot) ot.checked = true; }
        }
      });
    });
  }
  if (document.readyState !== 'loading') wire(document); else document.addEventListener('DOMContentLoaded', function(){ wire(document); });
  document.addEventListener('shopify:section:load', function(e){ wire(e.target); });
})();
